import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Components/Particles/Particle";

function Projects() {
  return (
    <Container fluid className="project-section" style={{ backgroundColor: "#1a1a1a", minHeight: "100vh", overflowX: "hidden" }}>
      <Particle />
      <Container style={{ paddingTop: "60px" }}>
        <h1 className="project-heading" style={{ color: "#fff" }}>
          My Recent <strong style={{ color: "#6C63FF" }}>Works </strong>
        </h1>
        <p style={{ color: "#fff", marginTop: "30px" }}>
          Here are a few projects I've worked on recently:
        </p>
        <div style={{ marginTop: "30px", width: "100%", height: "600px" }}>
          <iframe src="https://umaajay.netlify.app/" style={{ border: "none", width: "100%", height: "100%" }}></iframe>
        </div>
      </Container>
    </Container>
  );
}

export default Projects;
